export enum OperationActive {
    SEND = 'S',
    RECEIVE = 'R'
}